const digitalCuratorshipTypes = {
    youtube: "youtube",
    pdf: "pdf",
    link: "link",
};

export default digitalCuratorshipTypes;
